module.exports = __webpack_public_path__ + "img/level_1.0d72c5e1.png";